import ClickableIcon from '@/components/ClickableIcon'
import { Delete } from '@/components/Icons'

import messages from './messages'

export default ({ intl, onDelete }: any) => [
  {
    property: 'displayName',
    header: { label: intl.formatMessage(messages.name), sortable: true },
    cell: {
      formatters: [
        (displayName: any, { rowData }: any) => (
          <p className="user-display__name">
            <span className="user-display__name--emphasize">{displayName}</span>
            <span className="user-display__name--subtle">{rowData.email}</span>
          </p>
        )
      ]
    }
  },
  {
    property: 'id',
    cell: {
      formatters: [
        // TODO Make this a button
        (id: any) => <ClickableIcon callback={onDelete} parameter={id} render={Delete} />
      ]
    }
  }
]
